export const GET_PROSPECTS_REQUEST = 'GET_PROSPECTS_REQUEST';
export const GET_PROSPECTS_SUCCESS = 'GET_PROSPECTS_SUCCESS';
export const GET_PROSPECTS_FAILED = 'GET_PROSPECTS_FAILED';

export const POST_GENERATE_ROUTE_REQUEST = 'POST_GENERATE_ROUTE_REQUEST';
export const POST_GENERATE_ROUTE_SUCCESS = 'POST_GENERATE_ROUTE_SUCCESS';
export const POST_GENERATE_ROUTE_FAILURE = 'POST_GENERATE_ROUTE_FAILURE';
